import { PropsWithChildren } from 'react';

import { css } from '@emotion/react';
import { Button, SwipeableDrawer } from '@mui/material';
import { useTranslation } from '@scorenco/core';

import { T_KEYS } from '../../translations';

import { useDropDownContext } from './DropDownContext';

const DropDownMenuMobileCloseButton = () => {
  const { t } = useTranslation();
  const dropDownMenuContext = useDropDownContext();

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        dropDownMenuContext.close(true);
      }}
      css={css`
        display: flex;
        margin: 0.5rem 1rem;
        width: auto;
      `}
    >
      {t(T_KEYS.CANCEL)}
    </Button>
  );
};

export const DropDownMenuMobile = ({
  children,
  ...rest
}: PropsWithChildren) => {
  const dropDownMenuContext = useDropDownContext();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={dropDownMenuContext.isOpen}
      onClose={() => {
        dropDownMenuContext.close(true);
      }}
      onOpen={() => {
        dropDownMenuContext.open(dropDownMenuContext.triggerRef || null);
      }}
      css={css`
        .MuiDrawer-paper {
          max-height: 75vh;
          padding-top: 1rem;
          padding-bottom: calc(1rem + var(--ion-safe-area-bottom));
          max-width: 100vw;
        }
      `}
      {...rest}
    >
      {dropDownMenuContext.isOpen && children}
      {dropDownMenuContext.canCancel && <DropDownMenuMobileCloseButton />}
    </SwipeableDrawer>
  );
};
